// extracted by mini-css-extract-plugin
export default {"submit-button":"ResetPassword_submit-button__g0+ij"};